export const ADD_NAME = 'ADD_NAME';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SEND_ORDER = 'SEND_ORDER';
export const CLEAN_ORDER = 'CLEAN_ORDER';

// lista todas las acciones o estados posibles - sirve para coordinar entre desarrollador@s
// como guía y convención a la hora de escribir el código
